/*
 * FarmSteady — PDP add-on row controller (snippets/fs-pdp-addon.liquid).
 *
 * When the box is ticked, two hidden fields are appended to the product
 * form (and to the sticky ATC form, which has its own <form>):
 *   items[1][id]=<addon variant>&items[1][quantity]=1
 * alongside the form's normal id/quantity. /cart/add.js accepts that
 * mixed shape (verified on this shop 2026-08-18: one request, both lines
 * added, ReBuy drawer opens once with both). The original `id` input is
 * left ENABLED on purpose: Dawn's product-form.js reads it for its
 * cartUpdate/cartError events and the dynamic-checkout (Buy with Shop)
 * button reads it too. Unticking removes the fields.
 */
(function () {
  'use strict';

  function forms() {
    var list = [];
    var main = document.querySelector('form[data-type="add-to-cart-form"]');
    if (main) list.push(main);
    document.querySelectorAll('form[data-fs-sticky-atc-form]').forEach(function (f) { list.push(f); });
    return list;
  }

  function setAddon(form, addonId, on) {
    if (!form.querySelector('input[name="id"]')) return;
    form.querySelectorAll('[data-fs-addon-field]').forEach(function (el) { el.remove(); });
    if (!on) return;
    [
      ['items[1][id]', addonId],
      ['items[1][quantity]', '1']
    ].forEach(function (pair) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      input.setAttribute('data-fs-addon-field', '');
      form.appendChild(input);
    });
  }

  function init() {
    var check = document.querySelector('[data-fs-addon-check]');
    if (!check) return;
    var addonId = check.getAttribute('data-fs-addon-variant');
    var wrap = check.closest('[data-fs-addon]');

    function apply() {
      var on = check.checked;
      if (wrap) wrap.classList.toggle('fs-addon--on', on);
      forms().forEach(function (f) { setAddon(f, addonId, on); });
    }

    check.addEventListener('change', apply);
    apply();
  }

  if (['interactive', 'complete'].indexOf(document.readyState) !== -1) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
